


import { Switch, Form, Input, Select } from "antd"
import TextArea from "antd/es/input/TextArea"
import { useEffect, useState } from "react"
import UserRoleDropdown from "../../UserRoleDropdown"
import { useTranslation } from 'react-i18next';

const dateFormats = [
    { label: 'DD-MM-YYYY', value: 'DD-MM-YYYY' },
    { label: 'MM-DD-YYYY', value: 'MM-DD-YYYY' },
    { label: 'YYYY-MM-DD', value: 'YYYY-MM-DD' },
    { label: 'MM-YYYY', value: 'MMMM-YYYY' },
    { label: 'YYYY', value: 'YYYY' },
]

const UserPickerForm = ({isDisabled=false, formValues, form }) => {
    const { t } = useTranslation();
    const [userValues, setUserValues] = useState({user: [], role: [], group: []})
    useEffect(() => {
        if(formValues?.userValues){
          if(typeof formValues.userValues === "string"){
            setUserValues(JSON.parse(formValues.userValues))
    
          } else {
            setUserValues(formValues.userValues)
          }
        }
      },[formValues])

      let tabsRequired = []
  if(formValues){
    if(!formValues.disableUser) {
        tabsRequired.push('user')
    }
    if(!formValues.disableGroup) {
        tabsRequired.push('group')
    }
  }

  const handleSelect = (values) => {
    form.setFieldValue("userValues",values)
    setUserValues({...values})
  }

    return (
        <>
            <Form.Item name="label" label={t('Label')}>
                <Input placeholder={t('Enter label')} />
            </Form.Item>

            <Form.Item name="placeholder" label={t('Placeholder')}>
                <Input placeholder={t('Enter placeholder')} />
            </Form.Item>

            <Form.Item name="tooltip" label={t('Tooltip')} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            {
                formValues && formValues.tooltip &&
                <Form.Item label="" name="helpText">
                    <TextArea rows={2} placeholder={t('Enter help text')} />
                </Form.Item>
            }

            <Form.Item name="mandatory" label={t('Mandatory')} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="readOnly" label={t('Read only')} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="hideInitially" label={t('Hide initially')} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="allowSingleUser" label={t('Only one user allowed')} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>


            <Form.Item name="disableGroup" label={t('Disable group')} valuePropName="checked" className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="disableUser" label={t('Disable user')} valuePropName="checked" className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>
            <Form.Item name="disableUserWidget" label={t('Disable userpicker')} valuePropName="checked" className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>
            <Form.Item name="isRequestor" label={t('Is Requestor')} valuePropName="checked" className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>
            <Form.Item name="userValues" className="user-picker-dropdown-form" >
                <UserRoleDropdown dropdownStyle={{ marginBottom: "16px" }} disabled={isDisabled} selectedOptions={userValues} onSelect={handleSelect} getSpaceUsers={true} tabsRequired={tabsRequired} />
            </Form.Item>

        </>
    )
}

export default UserPickerForm